/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbAcquisScolaireGridDto } from './FcbAcquisScolaireGridDto';
import {
    FcbAcquisScolaireGridDtoFromJSON,
    FcbAcquisScolaireGridDtoFromJSONTyped,
    FcbAcquisScolaireGridDtoToJSON,
} from './FcbAcquisScolaireGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbAcquisScolaireGridDtoPaginatedResults
 */
export interface FcbAcquisScolaireGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbAcquisScolaireGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbAcquisScolaireGridDto>}
     * @memberof FcbAcquisScolaireGridDtoPaginatedResults
     */
    results?: Array<FcbAcquisScolaireGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbAcquisScolaireGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbAcquisScolaireGridDtoPaginatedResults interface.
 */
export function instanceOfFcbAcquisScolaireGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbAcquisScolaireGridDtoPaginatedResultsFromJSON(json: any): FcbAcquisScolaireGridDtoPaginatedResults {
    return FcbAcquisScolaireGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbAcquisScolaireGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbAcquisScolaireGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbAcquisScolaireGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbAcquisScolaireGridDtoPaginatedResultsToJSON(value?: FcbAcquisScolaireGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbAcquisScolaireGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

